// ProtectedRoute.jsx

import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';

const ProtectedRoute = ({ allowedRole, children }) => {
  const { isLoggedIn, isVerified, userData } = useSelector(
    (state) => state.authReducer,
  );
  const location = useLocation();

  if (!isLoggedIn || !isVerified) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (userData?.role !== allowedRole) {
    return <Navigate to="/404" replace />;
  }

  return children;
};

export default ProtectedRoute;
